<template>
  <v-row justify="center">
    <v-dialog
      v-model="isOpen"
      v-if="isOpen"
      fullscreen
      hide-overlay
      :transition="false"
      :retain-focus="false"
      origin="center top">
      <v-card class="session-schedule-dialog">
        <v-toolbar class="day-schedule-header">
          <v-btn icon dark @click="getClosed()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-toolbar-title
            ><span class="text-uppercase">{{
              $t("sessionSchedule.title")
            }}</span></v-toolbar-title
          >
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-container v-if="isSessionSelectedDetailsLoading">
          <v-skeleton-loader
            type="article, divider, article, divider, article: heading, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line"></v-skeleton-loader>
        </v-container>
        <div class="pl-7 pt-4 pr-7" v-else>
          <h1>
            {{
              sessionSelectedDetails
                ? sessionSelectedDetails.name
                : $t("sessionSchedule.unavailable")
            }}
          </h1>
          <v-row class="pt-7">
            <v-col cols="12" md="2" sm="3" class="summary">
              <div class="submenu">
                <v-icon>mdi-calendar-month-outline</v-icon>
                <span>
                  {{
                    sessionSelectedDetails
                      ? getDate(sessionSelectedDetails.start)
                      : $t("sessionSchedule.unavailable")
                  }}
                </span>
              </div>
              <div class="submenu">
                <v-icon>mdi-clock-outline</v-icon>
                <span>
                  {{
                    sessionSelectedDetails
                      ? getTime(
                          sessionSelectedDetails.start,
                          sessionSelectedDetails.end
                        )
                      : $t("sessionSchedule.unavailable")
                  }}
                </span>
              </div>
              <div class="submenu">
                <v-icon>mdi-book-outline</v-icon>
                <span>
                  {{
                    sessionSelectedDetails && sessionSelectedDetails.sessionType
                      ? sessionSelectedDetails.sessionType
                      : $t("sessionSchedule.unavailable")
                  }}
                </span>
              </div>
              <div class="submenu">
                <v-icon>mdi-map-marker-outline</v-icon>
                <span>
                  {{
                    sessionSelectedDetails && sessionSelectedDetails.type
                      ? sessionSelectedDetails.type
                      : " "
                  }}
                </span>
              </div>
              <!-- <div v-if="sessionSelectedDetails.description != ''">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" class="submenu">
                      <v-icon style="align-items: start"
                        >mdi-account-circle-outline</v-icon
                      >
                      <span v-html="sessionSelectedDetails.description"></span>
                    </div>
                  </template>
                  <span>{{ $t("sessionSchedule.moderators") }}</span>
                </v-tooltip>
              </div> -->
            </v-col>

            <v-col cols="12" md="10" sm="9" class="pt-1">
              <div style="font-weight: initial;" v-html="sessionSelectedDetails.description"></div>
              <br>
              <div v-if="sessionSelectedDetails.presentations.length > 0">
                <h3 class="pb-6">{{ $t("sessionSchedule.presentations") }}</h3>
                <div v-for="(presentation, i) in sortedPresentations" :key="i">
                  <speaker-card
                    :title="presentation.name"
                    :presentationTitles="presentation.presentationTitles"
                    :languages="presentation.languages"
                    :isAbstractAvailable="presentation.isAbstractAvailable"
                    :time="
                      getTime(
                        presentation.start,
                        presentation.end,
                        sessionSelectedDetails.start,
                        sessionSelectedDetails.end
                      )
                    "
                    :applicants="presentation.applicants"
                    :id="presentation.id"></speaker-card>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import SpeakerCard from "./SpeakerCard";

export default {
  name: "SessionScheduleDialog",
  data() {
    return {};
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    sortedPresentations() {
      // Use the spread operator to create a new array and then sort it
      return [...this.sessionSelectedDetails.presentations].sort((a, b) => {
        // Compare by start time first
        if (a.start < b.start) {
          return -1;
        }
        if (a.start > b.start) {
          return 1;
        }

        // If start times are equal, compare by end time
        if (a.end < b.end) {
          return -1;
        }
        if (a.end > b.end) {
          return 1;
        }

        // If start and end times are equal, leave the order unchanged
        return 0;
      });
    },

    daySelected: {
      get() {
        return this.$store.getters["getDaySelected"];
      },
      set(day) {
        return this.$store.dispatch("changeDaySelected", day);
      },
    },
    sessionSelected: {
      get() {
        return this.$store.getters["getSessionSelected"];
      },
      set(session) {
        return this.$store.dispatch("changeSessionSelected", session);
      },
    },
    sessionSelectedDetails: {
      get() {
        return this.$store.getters["getSessionSelectedDetails"];
      },
    },
    isSessionSelectedDetailsLoading: {
      get() {
        return this.$store.getters["getIsSessionSelectedDetailsLoading"];
      },
    },
  },
  methods: {
    getDate(date) {
      if (date == null || this.$dayjs(date).get("year") == 1901) {
        return this.$t("calendar.onDemand");
      } else {
        return this.$dayjs(date).format("DD MMM YYYY");
      }
    },
    getTime(startDate, endDate, sessionStartDate, sessionEndDate) {
      if (startDate == null) startDate = sessionStartDate;
      if (endDate == null) endDate = sessionEndDate;

      if (startDate == null || this.$dayjs(startDate).get("year") == 1901) {
        return this.$t("calendar.onDemand");
      } else {
        return (
          this.$dayjs(startDate).format("HH:mm") +
          " - " +
          this.$dayjs(endDate).format("HH:mm")
        );
      }
    },
    getClosed() {
      this.$emit("closed", true);
    },
  },
  watch: {},
  components: {
    "speaker-card": SpeakerCard,
  },
};
</script>
